import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Row, Col } from "react-bootstrap";
import LibrarySideBarHeader from "../../components/header/LibrarySideBarHeader";
import CustomMenu from "../../../../../../../../../shared/components/CustomMenu/CustomMenu";
import { useHistory, useLocation } from "react-router-dom";
import { DashboardLibraryPages } from "../../../../../../../containers/library/containers/LibraryRoutes";
import { useWorkshops } from "../../../../../../../../../contexts/workshops-context/WorkshopsContext";
import { useFunctions } from "reactfire";
import { Country } from "../../../../../../../../../shared/constants/Constant";
import { zeroPad } from "../../../../../../../../../shared/utils/Commons";
import {
  SubsectionStatus,
  useAppUser,
} from "../../../../../../../../../contexts/user-context/UserContext";
import { MdCheck } from "react-icons/md";
import SelectCountry from "../../../../../../../../../shared/components/countrySelectorModal/SelectCountry";
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from "react-beautiful-dnd";
import { BarLoader } from "react-spinners";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { DashboardPublicLibraryPages } from "../../../../../../../containers/public/containers/PublicLibrary";

interface IProps {
  type: "PUBLIC" | "PRIVATE";
}

const SubMenuCourses = (props: IProps) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const workshops = useWorkshops();
  const [modalShow, setModalShow] = useState(false);
  const appUser = useAppUser();

  return (
    <>
      <Row>
        <Col xs={12}>
          <LibrarySideBarHeader {...props} />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <CustomMenu
            data={
              props.type === "PRIVATE"
                ? [
                    {
                      onClick: () => {
                        if (workshops.country !== "DEFAULT") {
                          history.push(DashboardLibraryPages.HOME);
                        } else {
                          setModalShow(true);
                        }
                      },
                      text: "Library Home",
                      isActive: pathname === DashboardLibraryPages.HOME,
                    },
                    {
                      onClick: () => {
                        if (workshops.country !== "DEFAULT") {
                          history.push(DashboardLibraryPages.CURRICULUM);
                        } else {
                          setModalShow(true);
                        }
                      },
                      text: "Curriculum",
                      isActive: pathname === DashboardLibraryPages.CURRICULUM,
                    },
                    {
                      onClick: () => {
                        if (
                          workshops.country !== "DEFAULT" &&
                          pathname !== DashboardLibraryPages.WORKSHOPS
                        ) {
                          history.push(DashboardLibraryPages.WORKSHOPS);
                        } else {
                          setModalShow(true);
                        }
                      },
                      text: "Workshops",
                      isActive: pathname === DashboardLibraryPages.WORKSHOPS,
                      expandableData: <WorkshopsMenu {...props} />,
                    },
                    // { onClick: () => {}, text: "Announcements" },
                    // { onClick: () => {}, text: "Discussion (Forum)" },
                  ]
                : [
                    {
                      onClick: () => {
                        history.push(DashboardPublicLibraryPages.PUBLIC_HOME);
                      },
                      text: "Library Home",
                      isActive:
                        pathname === DashboardPublicLibraryPages.PUBLIC_HOME,
                    },
                    // {
                    //   onClick: () => {
                    //     history.push(
                    //       DashboardPublicLibraryPages.PUBLIC_CURRICULUM
                    //     );
                    //   },
                    //   text: "Curriculum",
                    //   isActive:
                    //     pathname ===
                    //     DashboardPublicLibraryPages.PUBLIC_CURRICULUM,
                    // },
                    {
                      onClick: () => {
                        history.push(
                          DashboardPublicLibraryPages.PUBLIC_WORKSHOPS
                        );
                      },
                      text: "Workshops",
                      isActive:
                        pathname ===
                        DashboardPublicLibraryPages.PUBLIC_WORKSHOPS,
                      expandableData: <WorkshopsMenu {...props} />,
                    },
                    // { onClick: () => {}, text: "Announcements" },
                    // { onClick: () => {}, text: "Discussion (Forum)" },
                  ]
            }
          />
        </Col>
      </Row>
      {appUser.userRole.isAdmin && props.type === "PRIVATE" && (
        <SelectCountry
          show={modalShow}
          onHide={() => {
            setModalShow(false);
          }}
        />
      )}
    </>
  );
};

interface Workshop {
  id: string;
  title: string;
  description: string;
  createdAt: Date;
  country: Country;
  orderNo: number;
}

const WorkshopsMenu = (props: IProps) => {
  // const [workshops, setWorkshops] = useState<Workshop[]>([]);
  const { workshops, publicWorkshops } = useWorkshops();
  const appUser = useAppUser();
  const { country } = useWorkshops();
  const [fWorkshops, setFWorkshops] = useState<Workshop[]>([]);
  useEffect(() => {
    const selectedCountry = country !== "DEFAULT";
    if (props.type === "PUBLIC") {
      setFWorkshops((ps) => {
        return publicWorkshops.sort(
          (a: Workshop, b: Workshop) => a.orderNo - b.orderNo
        );
      });
    } else {
      if (selectedCountry) {
        setFWorkshops((ps) => {
          return workshops
            .filter((w) => w.country === country)
            .sort((a: Workshop, b: Workshop) => a.orderNo - b.orderNo);
        });
      } else {
        // TODO show the error message. User must select a country.
      }
    }
  }, [country, workshops, props.type, publicWorkshops]);

  const updateWorkshopsOrderFunctionRef = useFunctions().httpsCallable(
    props.type === "PUBLIC"
      ? "updatePublicWorkshopOrders"
      : "updateWorkshopOrdersByCountry"
  );

  const [loading, setLoading] = useState(false);

  const onDragEnd = (result: DropResult) => {
    const from = result.source.index;
    const to = result.destination?.index;

    if (to !== undefined) {
      const a: Workshop[] = Object.assign([], fWorkshops);
      const [removed] = a.splice(from, 1);
      a.splice(to, 0, removed);

      setFWorkshops(a);
      const data =
        props.type === "PUBLIC"
          ? {
              workshopOrders: a.map((w, index) => ({
                workshopId: w.id,
                orderNo: index + 1,
              })),
            }
          : {
              country,
              workshopOrders: a.map((w, index) => ({
                workshopId: w.id,
                orderNo: index + 1,
              })),
            };
      setLoading(true);
      updateWorkshopsOrderFunctionRef(data)
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          if (to !== undefined) {
            setFWorkshops((ps) => {
              const a = Object.assign([], ps);
              const [removed] = a.splice(to, 1);
              a.splice(from, 0, removed);
              return a;
            });
          }
          setLoading(false);
        });
    }
  };

  return (
    <div className="xxsubsections-menu-wrapper">
      <BarLoader
        height={4}
        width={"100%"}
        color={"#ffffff"}
        loading={loading}
      />
      <DragDropContext
        onDragEnd={onDragEnd}
        onDragStart={() => {
          // setShowButtons(false);
        }}
      >
        <Droppable
          droppableId="droppable2"
          isDropDisabled={!appUser.userRole.isModerator}
        >
          {(provided, snapshot) => (
            <ul {...provided.droppableProps} ref={provided.innerRef}>
              {fWorkshops.map((work, index) => (
                <Draggable
                  draggableId={work.id}
                  index={index}
                  // isDragDisabled={uploading}
                  isDragDisabled={!appUser.userRole.isModerator || loading}
                  key={work.id}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.dragHandleProps}
                      {...provided.draggableProps}
                    >
                      <WorkshopMenuItem
                        type={props.type}
                        title={`${zeroPad(index + 1, 2)}. ${work.title}`}
                        completed={
                          !appUser.userRole.isModerator &&
                          appUser.workshopProgress.filter(
                            (w) => w.workshopId === work.id
                          )[0]?.status === SubsectionStatus.DONE
                        }
                        workshopId={work.id}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
      {/* <ul>
        {fWorkshops.map((work, index) => (
          <WorkshopMenuItem
            key={index}
            title={`${zeroPad(index + 1, 2)}. ${work.title}`}
            completed={
              !appUser.userRole.isModerator &&
              appUser.workshopProgress.filter(
                (w) => w.workshopId === work.id
              )[0]?.status === SubsectionStatus.DONE
            }
            workshopId={work.id}
          />
        ))}
      </ul> */}
    </div>
  );
};

interface IPropsSMI {
  completed?: boolean;
  title: string;
  workshopId: string;
  type: "PUBLIC" | "PRIVATE";
}

const WorkshopMenuItem = (props: IPropsSMI) => {
  const { push } = useHistory();
  const appUser = useAppUser();
  return (
    <li
      onClick={() => {
        if (props.type === "PUBLIC") {
          push(`/dashboard/public/workshops/${props.workshopId}`);
        } else {
          push(`/dashboard/workshops/${props.workshopId}`);
        }
      }}
      style={
        appUser.userRole.isModerator
          ? { justifyContent: "flex-start" }
          : { justifyContent: "space-between" }
      }
    >
      {appUser.userRole.isModerator && (
        <div className="sub-icon" style={{ marginRight: "10px" }}>
          <BiDotsVerticalRounded />
        </div>
      )}
      <div className="sub-title">{props.title}</div>
      <div className="sub-mark">
        {props.completed && (
          <span>
            <MdCheck />
          </span>
        )}
      </div>
    </li>
  );
};

export default SubMenuCourses;
